import { PropsWithChildren } from "react";

import { Tab } from "./UI/Tab/Tab";

import classes from "./Tabs.module.css";

type Props = PropsWithChildren;

export const Tabs = ({ children }: Props) => {
  return <div className={classes.tabs}>{children}</div>;
};

Tabs.Tab = Tab;
